import { type DOMNode, domToReact } from 'html-react-parser';
import { AccordionItem } from './AccordionItem';
import type { EnhancedDOMNode } from './Include';

type Props = {
  icon?: string;
  panel?: string | EnhancedDOMNode[];
  header?: string | EnhancedDOMNode[];
  panelclass?: string;
  headerclass?: string;
  elementsToRender?: DOMNode[];
};

export const Accordion = ({ elementsToRender, ...props }: Props) => {
  let panel: EnhancedDOMNode[] | string | null = null;
  let header: EnhancedDOMNode[] | string | null = null;

  if (props.header) {
    header = props.header;
  }

  if (props.panel) {
    panel = props.panel;
  }

  if (elementsToRender) {
    (elementsToRender as EnhancedDOMNode[]).forEach((el) => {
      switch (el.tagName) {
        case 'accordianheader':
          header = el.children;
          break;
        case 'accordianpanel':
          panel = el.children;
          break;
        case 'header':
          header = el.children;
          break;
        case 'panel':
          panel = el.children;
          break;
      }
    });
  }

  return (
    <div>
      <AccordionItem
        {...props}
        header={
          typeof header === 'string' ? (
            <div dangerouslySetInnerHTML={{ __html: header }} />
          ) : (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            header && domToReact(header)
          )
        }
        panel={
          typeof panel === 'string' ? (
            <div dangerouslySetInnerHTML={{ __html: panel }} />
          ) : (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            panel && domToReact(panel)
          )
        }
      />
    </div>
  );
};

export default Accordion;
